import React from "react";
import { Link } from "react-router-dom";
import { Zap } from "lucide-react";

// Logo textual do Pronto.AI. `variant` controla cor do texto (dark/light bg).
export function Logo({ variant = "dark", className = "", to = "/" }) {
  const textColor = variant === "light" ? "text-slate-900" : "text-white";
  const content = (
    <span className={`inline-flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <span className="relative flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-violet-500 to-cyan-400 glow-violet">
        <Zap className="h-5 w-5 text-slate-950" fill="currentColor" />
      </span>
      <span className={`font-display text-xl font-extrabold tracking-tight ${textColor}`}>
        Pronto<span className="gradient-text">.AI</span>
      </span>
    </span>
  );
  if (to) return <Link to={to} className="no-underline">{content}</Link>;
  return content;
}
